import { forwardRef } from 'react';
import { RakeLayout } from '@meitu/rake';
import { talentRoute } from '@/routes';

export default forwardRef<HTMLDivElement>(function Talent(props, ref) {
  return <RakeLayout.RoutesContent ref={ref} routeItem={talentRoute} />;
});
